// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2440":"e6c08290","5189":"e6c08290"}[chunkId] + ".chunk.css";
};